import { gsap } from "gsap";
import React, { useEffect, useRef } from "react";

const OUTER_PETALS = 8;
const INNER_PETALS = 8;
const OUTER_COLORS = ["#990000", "#7a1a3a", "#990000", "#7a1a3a", "#990000", "#7a1a3a", "#990000", "#7a1a3a"];
const INNER_COLORS = ["#c77dff", "#a4acc4", "#c77dff", "#a4acc4", "#c77dff", "#a4acc4", "#c77dff", "#a4acc4"];

function SpinningFlower() {
  const outerGroupRef = useRef(null);
  const innerGroupRef = useRef(null);
  const centerRef     = useRef(null);
  const outerRefs     = useRef([]);
  const innerRefs     = useRef([]);

  useEffect(() => {
    // Outer ring spins clockwise slowly
    gsap.to(outerGroupRef.current, {
      rotation: 360,
      duration: 14,
      repeat: -1,
      ease: "none",
      transformOrigin: "80px 80px",
    });

    // Inner ring spins counter-clockwise faster
    gsap.to(innerGroupRef.current, {
      rotation: -360,
      duration: 9,
      repeat: -1,
      ease: "none",
      transformOrigin: "80px 80px",
    });

    // Outer petals breathe with stagger
    gsap.to(outerRefs.current, {
      scaleY: 1.22,
      scaleX: 0.88,
      duration: 1.8,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      stagger: { each: 0.22, from: "start" },
      transformOrigin: "80px 80px",
    });

    // Inner petals breathe offset
    gsap.to(innerRefs.current, {
      scaleY: 1.28,
      scaleX: 0.82,
      duration: 1.3,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      stagger: { each: 0.16, from: "end" },
      transformOrigin: "80px 80px",
    });

    // Center pulse
    gsap.to(centerRef.current, {
      scale: 1.18,
      duration: 1.6,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      transformOrigin: "80px 80px",
    });
  }, []);

  const outerPetals = Array.from({ length: OUTER_PETALS }, (_, i) => ({
    angle: i * (360 / OUTER_PETALS),
    fill: OUTER_COLORS[i],
  }));

  const innerPetals = Array.from({ length: INNER_PETALS }, (_, i) => ({
    angle: i * (360 / INNER_PETALS) + 22.5,
    fill: INNER_COLORS[i],
  }));

  return (
    <div className="mi-flower-wrap">
      <svg
        viewBox="0 0 160 160"
        width="260"
        height="260"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer petals group */}
        <g ref={outerGroupRef}>
          {outerPetals.map((p, i) => (
            <ellipse
              key={i}
              ref={(el) => (outerRefs.current[i] = el)}
              cx="80"
              cy="38"
              rx="13"
              ry="34"
              fill={p.fill}
              opacity="0.88"
              transform={`rotate(${p.angle} 80 80)`}
            />
          ))}
        </g>

        {/* Inner petals group */}
        <g ref={innerGroupRef}>
          {innerPetals.map((p, i) => (
            <ellipse
              key={i}
              ref={(el) => (innerRefs.current[i] = el)}
              cx="80"
              cy="54"
              rx="8"
              ry="20"
              fill={p.fill}
              opacity="0.75"
              transform={`rotate(${p.angle} 80 80)`}
            />
          ))}
        </g>

        {/* Center */}
        <g ref={centerRef}>
          <circle cx="80" cy="80" r="17" fill="#ffd166" opacity="0.95" />
          <circle cx="80" cy="80" r="10" fill="#ffffff" opacity="0.55" />
          <circle cx="80" cy="80" r="4"  fill="#990000" opacity="0.8" />
        </g>
      </svg>
    </div>
  );
}

export default SpinningFlower;
